<template>
  <div :class="classObj" class="app-wrapper">
    <!-- <div v-if="device === 'mobile' && true" class="drawer-bg" @click="handleClickOutside" /> -->
    <MapSidebar class="sidebar-container" />
    <div class="main-container">
      <app-main />
    </div>
  </div>
</template>

<script>
import { MapSidebar, AppMain } from './components';
import ResizeMixin from './mixin/resize-handler';

export default {
  name: 'mapLayout',
  components: {
    MapSidebar,
    AppMain,
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: false,
        openSidebar: true,
        withoutAnimation: true,
        mobile: this.device === 'mobile',
      };
    },
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('CloseSideBar', { withoutAnimation: false });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/assets/styles/mixin.scss";

.app-wrapper {
  @include clearfix;

  position: relative;
  height: 100%;
  width: 100%;
  display: flex;

  &.mobile.openSidebar {
    position: absolute;
    top: 0;
  }
}
.main-container{
  flex: 1;
  margin-left: 0!important;
}
.sidebar-container{
  position: relative!important;
}
.drawer-bg {
  background: #000;
  opacity: .3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
</style>
